import * as React from 'react'

import { IFlatQuery } from '../../../../common/utils/location/types'
import { IRecommendedSearches } from '../../../../typings/recommendedSearches'
import PillsNav from '../../../components/pillsNav'

import * as styles from './relatedSearches.module.css'

const RelatedSearches = ({
  recommendations,
  type,
  hint
}: IRecommendedSearches) => (
  <div className={styles.root}>
    <p className={styles.title}>
      Searches related to
      <span className={styles.bold}> {hint}</span>
    </p>
    {type && (
      <PillsNav>
        {recommendations.map((term: string, index: number) => {
          const nextQuery: IFlatQuery = {}
          nextQuery[type] = term

          return (
            <PillsNav.Pill
              key={index}
              locationParams={nextQuery}
              hash="content"
            >
              {term}
            </PillsNav.Pill>
          )
        })}
      </PillsNav>
    )}
  </div>
)

export default RelatedSearches
